export default __webpack_public_path__ + "static/media/message_disable.a0e9b7b0.svg";